import { Page } from '@builder/types'
import { api, ApiRes } from './client'

export const getPages = (): ApiRes<Page[]> => {
    return api.get('v2/manage/pages')
}

export const getPageBySlug = (slug: string): ApiRes<Page> => {
    return api.get(`v2/manage/pages/${slug}`)
}

export const storePage = (page: {
    title: string
    description: string
    slug: string
    platform_name: string
}): ApiRes<Page> => {
    return api.post('v2/manage/pages', page)
}

export const updatePage = (
    page: Omit<Page, 'platform_name' | 'created_at' | 'updated_at'>
): ApiRes<Page> => {
    return api.put(`v2/manage/pages/${page.id}`, page)
}

export const createPreviewToken = (
    pageData: Omit<Page, 'platform_name' | 'created_at' | 'updated_at'>
): ApiRes<{ token: string }> => {
    return api.post('v2/manage/pages/preview', pageData)
}
